import React from "react"
import { useStaticQuery, graphql } from "gatsby";

const GoogleReviewsScoreStatic = (props) => {
    const latestReviewsScore = useStaticQuery(graphql`
        query {
            allStrapiGoogleReviewReviews {
                edges {
                    node {
                        id
                        starRating
                    }
                },
                pageInfo {
                    totalCount
                }
            }
        }
    `)
    const reviews = latestReviewsScore.allStrapiGoogleReviewReviews.edges;
    const reviewsCount = latestReviewsScore.allStrapiGoogleReviewReviews.pageInfo.totalCount;
    const wordToNumber = {'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5};
    let sumOfScores = 0;

    reviews.map((review) => {
        const reviewStringValue = review.node.starRating;
        sumOfScores += wordToNumber[reviewStringValue];
        return(sumOfScores)
    })

    const averageRating = Math.round(sumOfScores / reviewsCount * 10) / 10;

    return (
        <h4 className="review-title">{averageRating}/5 from 3,216 Customer Reviews</h4>
    );
}

export default GoogleReviewsScoreStatic
